<template>
  <div class="all-done-container">
    <Typography variant="h-2">All done!</Typography>
    <Robin :height="120" :width="140" class="" :loop="false" animation="backflip" />
    <Button @click="$emit('close')"> Close </Button>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography";
import Robin from "@/components/Robin";
import Button from "@/components/generic/Button";
export default {
  name: "AllDone",
  components: {
    Typography,
    Robin,
    Button,
  },
};
</script>

<style scoped>
.all-done-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 3rem;
  gap: 2rem;
}
</style>
